'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Email component used to get the user's email address
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - used with account creation and can be a hidden input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		transition: 'all 0.25s ease-in-out'
	}
});

var Email = function (_React$Component) {
	_inherits(Email, _React$Component);

	function Email() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Email);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Email.__proto__ || Object.getPrototypeOf(Email)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showIsRequiredError: false }, _this.handleChangeEmail = function (email) {
			_this.handleCheckForValue(email);
			_this.props.changeEmail(email);
			return email;
		}, _this.handleCheckForValue = function (email) {
			_this.setState({ showIsRequiredError: _this.props.required && !email });
		}, _this.handleFocus = function (email) {
			_this.props.handleFocus(email);
		}, _this.handleBlur = function (email) {
			_this.handleCheckForValue(email);
			_this.props.handleBlur(email);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	/**
 * Handle changing the email
 * Calls parent's handler
 * @param {String} email - the user's email
 */


	/**
 * Check for an email value
 * If the field is required, we should show that this field needs a value
 * @param {String} email - user's email
 */


	/**
 * Call parent's handleFocus
 * @param {String} email - user's email
 */


	/**
 * Check for an email value and call parent's handleBlur
 * @param {String} email - user's email
 */


	_createClass(Email, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    initialValue = _props.value,
			    errorMessage = _props.errorMessage;

			var errorStyles = {
				height: 0,
				padding: 0
			};
			if (errorMessage) {
				errorStyles = { height: '100%' };
			}

			// define the wrapper classNames, which handle showing error messages
			var wrapperClassNames = (0, _classnames2.default)({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': !errorMessage && this.state.showIsRequiredError
			});

			// input classNames based on if the input should be hidden
			var emailClassNames = (0, _classnames2.default)({
				hidden: this.props.type === 'hidden',
				'vx_form-control': this.props.type !== 'hidden',
				'vx_form-control_complex': this.props.type !== 'hidden'
			});

			return _react2.default.createElement(
				'div',
				{ className: wrapperClassNames, style: { margin: '10px 0 0', position: 'relative' } },
				_react2.default.createElement(_reactTextInput2.default, {
					type: this.props.type,
					name: 'email',
					id: 'email',
					className: emailClassNames,
					label: this.props.label,
					helpText: this.props.helpText,
					required: this.props.required,
					value: initialValue,
					errorMessage: this.props.errorMessage,
					handleChange: this.handleChangeEmail,
					handleFocus: this.handleFocus,
					handleBlur: this.handleBlur
				}),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage), {
							'vx_form-control-message': errorMessage
						}), style: errorStyles },
					errorMessage
				)
			);
		}
	}]);

	return Email;
}(_react2.default.Component);

Email.propTypes = {
	type: _propTypes2.default.string.isRequired,
	label: _propTypes2.default.string,
	helpText: _propTypes2.default.string,
	required: _propTypes2.default.bool,
	value: _propTypes2.default.string,
	errorMessage: _propTypes2.default.string,
	changeEmail: _propTypes2.default.func,
	handleFocus: _propTypes2.default.func,
	handleBlur: _propTypes2.default.func
};
Email.defaultProps = {
	type: 'email',
	handleFocus: function handleFocus() {},
	handleBlur: function handleBlur() {}
};
exports.default = Email;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Email.js
// module id = 701
// module chunks = 5